import { Injectable, Input, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { StaffBasicInfo } from '../Models/GlobalEntities';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { MasterDataService } from './MasterDataService';
import { PMSService } from './PMSService';
import { MessagingService } from './MessagingService';
import { DeviceTypes } from '../Models/EnumModels';


@Injectable({
    providedIn: 'root',
})
export class MessagingSignalRService extends BaseService {
    private _hubConnection: HubConnection;
    connectionEstablished = new EventEmitter<Boolean>();

    public connectionIsEstablished = false;
    GuestLookupChanged = new EventEmitter();

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, protected messagingService: MessagingService) {
        super();

    }

    public Init(): void {
        this.BaseURL = AppSettings.URL_Messaging;

        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }

    private createConnection() {
        var objThis = this;
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(this.BaseURL + 'MessagingHub?SessionId=' + objThis.masterService.apiService.getSessionCookie())
            .withAutomaticReconnect()
            .build();
    }

    private startConnection(): void {
        if (this._hubConnection == undefined || this._hubConnection == null) {
            this.createConnection();
        }

        this._hubConnection
            .start()
            .then(() => {
                this.connectionIsEstablished = true;
                //console.log('Hub connection started');
                this.connectionEstablished.emit(true);

            })
            .catch(err => {
                this.connectionIsEstablished = true;
                //console.log('Error while establishing connection, retrying...');
                if (!AppSettings.APP_DEBUG) {
                    window.setTimeout(() => { this.startConnection() }, 5000);
                }
            });
    }

    private registerOnServerEvents(): void {
        this._hubConnection.onclose(err => {
            this.connectionIsEstablished = false;
            this.connectionEstablished.emit(false);
            if (!AppSettings.APP_DEBUG) {
                window.setTimeout(() => { this.startConnection() }, 5000);
            }
        });

        this._hubConnection.on('Message_Notify', (data: any) => {
            //console.info(data);
            if (data != null)
                this.messagingService.IncomingMessage(data);
        });

        this.connectionEstablished.subscribe(data => {
            //console.info("C = " + data);
            if (data == true)
                this.RegisterUser();
        });
    }

    private RegisterUser(): void {
        //console.info(this.masterService.GetPropertyIDs());

        this._hubConnection.invoke("RegisterUser", DeviceTypes.PC).then(data => {
            //console.info(data);
        });
    }
}
